
// дескриптор поставки
export const CreateDelivery = {
  id: 'createDelivery',
  api: 'productsClientBridge',
  title: 'Создать поставку',
  // поля которые использует report table для отображения и доп функционала
  // кнопка для создания и скачивания пдф файла 
  pdf: false,
  // отображать чекбоксы для выбора строк
  showCheckboxes: false,
  // шторка с доп инфо
  details: true,
  // шторка с доп инфо по строке
  expanded: false,
  // нажатие на строку
  selectRow: false,
  additionalOrientation: "row",
  items: [{ id: 'data.cdn', title: '№' , width: '50px', visible: 'left' },
  { id: 'createdAt', title: 'Дата создания', formatter:"date" , width: '100px'},
  { id: 'data.logistic.pickupDate', title: 'Дата поступления', formatter:"date" , width: '100px'},
  { id: 'date_shipment', title: 'Дата отгрузки', formatter:"date" , width: '100px'},
  { id: 'includes_products', title: 'Товары', formatter: "DealProductsAllInfo", width: '250px'},
  { id: 'warehouse_tranzit', title: 'Транзитный склад', formatter: 'DefaultTypography', width: '180px'},
  { id: 'warehouse_market', title: 'Склад назначения', formatter: 'DefaultTypography', width: '180px'},
  { id: 'dealDetails', title: 'Детали', formatter: "DealDetails"},
  // { id: 'data.showStatus', title: 'Статус сделки', formatter: "StatusDeal", width: '100px' },
  { id: 'type', title: 'Статус сделки', formatter: "StatusDeal", width: '100px' },
  { id: 'status_pay', title: 'Статус оплаты', formatter: "StatusPay" , width: '120px'},
  { id: 'price', title: 'Сумма к оплате', formatter: "money", width: '150px' },
  ],
  showDetails: (obj) => {
    console.log('showDetails', obj);
  }
};


export const CreateDeliveryConsumes = {
  id: 'createDeliveryConsumes',
  api: 'productsClientBridge',
  title: 'Создать поставку',
  // поля которые использует report table для отображения и доп функционала
  // кнопка для создания и скачивания пдф файла 
  pdf: false,
  // отображать чекбоксы для выбора строк
  showCheckboxes: false,
  // шторка с доп инфо
  details: false,
  // шторка с доп инфо по строке
  expanded: false,
  // нажатие на строку
  selectRow: false,
  items: [
    { id: 'data.cdn', title: '№' , width: '50px' },
    { id: 'createdAt', title: 'Дата создания', formatter:"date" , width: '100px'},
    { id: 'data.logistic.pickupDate', title: 'Дата поступления', formatter:"date" , width: '100px'},
    { id: 'includes_products', title: 'Товары', formatter: "DealProductsAllInfoCons", width: '300px'},
    { id: 'type', title: 'Статус сделки', formatter: "StatusDeal", width: '100px' },
    { id: 'status_pay', title: 'Статус оплаты', formatter: "StatusPay" , width: '120px'},
    { id: 'count_bale', title: 'Кол-во мест', formatter: 'DefaultTypography', width: '200px'},
  ],
  // showDetails: (obj) => {
  //   console.log('showDetails', obj);
  // }
};

// дескриптор для добавления товаров в поставку
export const AddProducts = {
  id: 'addProducts',
  api: 'marketsBridge',
  title: 'Добавить товары в короб',
  showCheckboxes: true,
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo', width:'300px' },
    { id: 'countProduct', title: 'Кол-во', formatter: 'ProductCount', width:'80px' },
    { id: 'totalStorage', title: 'На хранении фф', formatter: 'StorageCount', width:'60px' },
    // { id: 'size.inbox', title: 'Квант', formatter: 'DefaultTypography', width:'60px'},
    // { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width:'50px'},
    // { id: 'size', title: 'Размер', formatter: 'ProductSize', width:'150px' },
    // { id: 'data.color', title: 'Цвет', formatter: 'ColorsList', width:'100px'},
    // { id: 'size', title: 'Штрих код', formatter: "BarCode"},
    // { id: 'size.barcode', title: 'Баркод', formatter: 'DefaultTypography', width:'150px'},
    
  ],
};

export const ChooseProducts = {
  id: 'chooseProducts',
  api: 'marketsBridge',
  title: 'Выбрать товар',
  showCheckboxes: true,
  items: [
    { id: 'data', title: 'Товар', formatter: 'Product', width:'300px' },
    { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width:'50px'},
    { id: 'currentBarcode', title: 'Баркод', formatter: 'DefaultTypography', width:'150px'},
  ],
};

export const ClientProducts = {
  id: 'ClientProducts',
  api: 'marketsBridge',
  title: 'Товары клиента',
  showCheckboxes: false,
  expanded: true,
  additionalOrientation: 'column',
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo', width: '400px' },
    // { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width: '150px', sortable:true},
    // { id: 'size', title: 'Размер', formatter: 'ProductSize', width: '170px' },
    { id: 'techTask', title: 'Техническое задание', formatter: 'UploadTechTaskButton', width: '400px', canHideTZ: true},
    { id: 'data.dimensions', title: 'Объем', formatter: 'ProductDim', width: '120px'},
    { id: 'size', title: 'Штрих код', formatter: "BarCodeChangable", width: '250px'},
    { id: 'qrcode', title: 'QR код', formatter: "UploadQrButton", width: '100px'},
    // { id: 'size.countQr', title: 'Кол-во QR', formatter: 'DefaultTypography', width: '100px', sortable:true},
    { id: 'size', title: 'Остатки на МП', formatter: 'ProductStocksTableBig', width: '190px'},
  ],
};

export const ClientProductsModern = {
  id: 'ClientProductsModern',
  api: 'marketsBridge',
  title: 'Товары клиента',
  showCheckboxes: false,
  expanded: false,
  additionalOrientation: 'column',
  items: [
    { id: 'wb.data', title: 'Товар WB', formatter: 'ProductMoreInfoProducts', width: '300px' },
    { id: 'ozon.data', title: 'Товар OZON', formatter: 'ProductMoreInfoProducts', width: '300px' },
    { id: 'custom.data', title: 'Товар CUSTOM', formatter: 'ProductMoreInfoProducts', width: '300px' },
    { id: 'qrcode', title: 'QR код', formatter: "UploadQrButton", width: '60px'},
    
  ],
};

export const ClientProductsAdmin = {
  id: 'ClientProductsAdmin',
  api: 'marketsBridge',
  title: 'Товары клиента',
  showCheckboxes: false,
  expanded: true,
  items: [
    { id: 'data', title: 'Товар', formatter: 'Product', width: '320px' , sortable:true},
    { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width: '150px', sortable:true},
    { id: 'size', title: 'Размер', formatter: 'ProductSize', width: '170px' },
    { id: 'techTask', title: 'Техническое задание', formatter: 'UploadTechTaskButtonOnlyVersons', width: '400px'},
    { id: 'techTask', title: 'Цена', formatter: 'TzPrice', width: '100px'},
    { id: 'data.dimensions', title: 'Объем', formatter: 'ProductDim', width: '120px'},
    { id: 'data', title: 'Штрих код', formatter: "barCodeFormat", width: '220px'},
    { id: 'size.countQr', title: 'Кол-во QR', formatter: 'DefaultTypography', width: '100px', sortable:true},
    { id: 'size', title: 'Остатки на МП', formatter: 'ProductStocksTableBig', width: '190px', sortable:true },
  ],
};

export const ClientBarcodes = {
  id: 'ClientBarcodes',
  api: 'marketsBridge',
  title: 'Штрих коды клиента',
  showCheckboxes: false,
  expanded: true,
  items: [
    { id: 'data', title: 'Товар', formatter: 'Product', width: '320px' , sortable:true},
    { id: 'data.vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', width: '150px', sortable:true},
    { id: 'size', title: 'Размер', formatter: 'ProductSize', width: '170px' },
    { id: 'mappingData', title: 'Штрих коды', formatter: "BarcodeMappingCell", width: '600px'},
  ],
};

export const ClientProductsStorage = {
  id: 'ClientProductsStorage',
  api: 'marketsBridge',
  title: 'Товары клиента',
  showCheckboxes: false,
  expanded: false,
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo', sortable: true },
    // { id: 'vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort', sortable: true},
    // { id: 'size', title: 'Размер', formatter: 'ProductSize' },
    // { id: 'size.techTask.version', title: 'Версия ТЗ', formatter: 'DefaultTypography'},
    { id: 'size', title: 'Версия ТЗ', formatter: 'ShowTechTaskVersion'},
    { id: 'dimensions', title: 'Объем', formatter: 'ProductDim', width: '120px'},
    // { id: 'size', title: 'Штрих код', formatter: "BarCode", width: '200px'},
    { id: 'countProduct', title: 'Количество', formatter: 'DefaultTypography', sortable: true},
    { id: 'total', title: 'Остатки на МП', formatter: 'DefaultTypography', sortable: true }, //другой форматтер, чтобы по ширине было норм
    { id: 'totalInRoad', title: 'В пути', formatter: 'DefaultTypography', sortable: true}
  ],
};

export const ClientProductsStorageCustom = {
  id: 'ClientProductsStorageCustom',
  api: 'marketsBridge',
  title: 'Товары клиента',
  showCheckboxes: false,
  expanded: false,
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo' },
    // { id: 'vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort'},
    // { id: 'size', title: 'Размер', formatter: 'ProductSize' },
    // { id: 'size.techTask.version', title: 'Версия ТЗ', formatter: 'DefaultTypography'},
    { id: 'size', title: 'Версия ТЗ', formatter: 'ShowTechTaskVersion'},
    { id: 'dimensions', title: 'Объем', formatter: 'ProductDim', width: '120px'},
    // { id: 'size', title: 'Штрих код', formatter: "BarCode", width: '200px'},
    { id: 'countProduct', title: 'Количество', formatter: 'DefaultTypography'},
    // { id: 'totalInRoad', title: 'В пути', formatter: 'DefaultTypography'}
  ],
};

export const ProductsForNewDeal = {
  id: 'ProductsForNewDeal',
  api: 'marketsBridge',
  title: 'Выберите товары',
  showCheckboxes: true,
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo' },
    // { id: 'vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort'},
    // { id: 'size', title: 'Размер', formatter: 'ProductSize' },
    // { id: 'size.techTask.version', title: 'Версия ТЗ', formatter: 'DefaultTypography'},
    // { id: 'size', title: 'Версия ТЗ', formatter: 'ShowTechTaskVersion'},
    // { id: 'color', title: 'Цвет', formatter: 'ColorsList'},
    { id: 'inbox', title: 'Квант', formatter: 'DefaultTypography'},
    { id: 'countInfo', title: 'Кол-во', formatter: 'ProductCountEditKratCount' },
    { id: 'storage_count', title: 'Кол-во на хранении', formatter: 'DefaultTypographyShort' },
  ],
};

export const ProductsForNewDealReturns = {
  id: 'ProductsForNewDealReturns',
  api: 'marketsBridge',
  title: 'Выберите товары',
  showCheckboxes: true,
  items: [
    { id: 'data', title: 'Товар', formatter: 'ProductMoreInfo' },
    // { id: 'vendorCode', title: 'Артикул', formatter: 'DefaultTypographyShort'},
    // { id: 'size', title: 'Размер', formatter: 'ProductSize' },
    // { id: 'color', title: 'Цвет', formatter: 'ColorsList'},
    { id: 'inbox', title: 'Квант', formatter: 'DefaultTypography'},
    { id: 'countInfo', title: 'Кол-во', formatter: 'ProductCountEditKratCount' },
    { id: 'storage_count', title: 'Всего', formatter: 'DefaultTypographyShort' },
  ],
};


export const ProductTotalCount = {
  id: 'ProductTotalCount',
  api: 'marketsBridge',
  title: 'Товары клиента',
  showCheckboxes: false,
  items: [
    { id: 'data', title: 'Товар', formatter: 'Product' , sortable:true},
    { id: 'sizes', title: 'Артикул', formatter: 'TitledList', sortable:true},
    // { id: 'data.totalCount', title: 'Остатки', formatter: 'DefaultTypography' },
    { id: 'countOnSizes', title: 'Остатки на МП', formatter: 'ProductStocksTable' , sortable:true},
    { id: 'inRoadOnSizes', title: 'В пути', formatter: 'ProductStocksTable' , sortable:true},
    { id: 'storageOnSize', title: 'На хранении фф', formatter: 'ProductStocksTable', sortable:true},
  ],
};

// дескриптор по тз
export const AddTech = {
  id: 'addTech',
  api: 'defBridge',
  title: 'Техническое задание',
  showCheckboxes: true,
  items: [{ id: 'service', title: 'Услуга', formatter: "Service" },
  { id: 'count', title: 'Количество', formatter: 'DefaultTypography'},
  ],
};

// дескриптор для PDF файлов в поставке
export const AddPdf = {
  id: 'addPdf',
  api: 'pdfBridge',
  title: 'Добавить QR-код',
  showCheckboxes: true,
  selectRow: true,
    items: [{ id: 'name', title: 'Файл', formatter: "PdfFile"},
  ],
};

// дескриптор для просмотра PDF файлов
export const ViewPdf = {
  id: 'viewPdf',
  api: 'defBridge',
  title: 'Файл',
  showCheckboxes: true,
  noHeader: true,
  items: [{ id: 'data', title: 'Страницы', formatter:"ImageBuffer" }],
};

export const ViewPdfUsed = {
  id: 'ViewPdfUsed',
  api: 'defBridge',
  title: 'Файл',
  showCheckboxes: false,
  noHeader: true,
  items: [{ id: 'data', title: 'Страницы', formatter:"UsedQRForCli" }],
};

export const viewIMG = {
  id: 'viewIMG',
  api: 'defBridge',
  title: 'Файл',
  showCheckboxes: true,
    items: [{ id: 'render', title: 'Страницы', formatter:"RTImage" },
  ],
};

export const MyConsumables = {
  id: 'MyConsumables',
  api: 'defBridge',
  title: 'Расходники',
  showCheckboxes: false,
  expanded: false,
  additionalOrientation: 'column',
  items: [
    { id: 'data', title: 'Расходник', formatter: 'ProductMoreInfo', width: '400px', sortable: true },
    { id: 'consum', title: 'Тип расходника', formatter: 'ConsumType'},
    // { id: 'size', title: 'Размер', formatter: 'DefaultTypography' },
    // { id: 'color', title: 'Цвет', formatter: 'DefaultTypography' },
    // { id: 'barcode', title: 'ШК', formatter: 'DefaultTypography' },
    { id: 'rck', title: 'Ед измерения', formatter: 'RCK'},
    { id: 'dimensions', title: 'Объем', formatter: 'ProductDim'},
    { id: ['count','rck'], title: 'На хранении фф', formatter: 'ConsumableCount', sortable: true },
  ],
};